module.exports = __webpack_public_path__ + "static/media/cdb12.32cd80c9.png";